import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { isString } from 'lodash';
import { useState } from 'react';
import { AxiosError } from 'axios';

import { showSnackbar } from '../../../api/snackbarSlice';
import { authApiClient } from '../../../api/axios';

const signup = async ({ payload }) => {
  const response = await authApiClient.post('/signup', payload);
  return response.data;
};

export const useSignupHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);

  const mutation = useMutation({
    mutationFn: signup,
    onSuccess: (data, variables, context) => {
      dispatch(showSnackbar({ message: 'Signup successful! Please check your email for verification.' }));
      queryClient.invalidateQueries({ queryKey: ['auth'] });
      onSuccess && onSuccess(data);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
      } else {
        dispatch(
          showSnackbar({
            message: isString(error.message) ? error.message : JSON.stringify(error.message),
            severity: 'error',
          }),
        );
      }
    },
  });

  const onSubmit = async (payload) => {
    mutation.mutate({ payload });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
